import { combineReducers } from 'redux';

import AppState from '../modules/App/AppState';

export default combineReducers({
  AppState
});



/** WEBPACK FOOTER **
 ** ./src/redux/reducer.js
 **/